/**
 * Created by ivo on 12.05.17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import t from '../../trans';

const propTypes = {
    title: PropTypes.node,
    /**
     * If form input fields and button should be disabled
     */
    disabled: PropTypes.bool,
    /**
     * Default value for e-mail address field
     */
    email: PropTypes.string,
    password: PropTypes.string,
    code: PropTypes.string,
    newPassword: PropTypes.string,
    newPassword2: PropTypes.string,
    /**
     * If e-mail field should be read-only
     */
    lockEmail: PropTypes.bool,
    /**
     * Should password form contain also two-factor code field
     */
    askCode: PropTypes.bool,
    /**
     * If true, then field for new password will be also displayed
     */
    changePassword: PropTypes.bool,
    /**
     * Called when user changes field value
     *  onChange(field, newValue)
     */
    onChange: PropTypes.func,
    /**
     * Callback function called when the user clicks to "Login" button.
     * Called with the signature:
     *  onSubmit(username, password, code [, newPassword, newPassword2])
     */
    onSubmit: PropTypes.func,
    /**
     * Callback function called when the user clicks to "Forgot password" link.
     */
    onForgotPassword: PropTypes.func,
    /**
     * Callback function called when the user clicks to "Cancel" button.
     * Signature:
     *      onCancel();
     * If this prop is not set then "Cancel" button will not be displayed
     */
    onCancel: PropTypes.func
};

const defaultProps = {
    title: null,
    disabled: false,
    lockEmail: false,
    askCode: false,
    changePassword: false
};

class PasswordForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: props.email,
            password: props.password,
            code: props.code,
            newPassword: props.newPassword,
            newPassword2: props.newPassword2
        };
        this.onChange = this.onChange.bind(this);
        this.onClickSubmit = this.onClickSubmit.bind(this);
        this.onClickForgotPassword = this.onClickForgotPassword.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.onChange) {
            this.setState({
                email: nextProps.email,
                password: nextProps.password,
                code: nextProps.code,
                newPassword: nextProps.newPassword,
                newPassword2: nextProps.newPassword2
            });
        }
    }

    onClickSubmit(e) {
        e.preventDefault();
        if (this.props.onSubmit) this.props.onSubmit(this.state.email, this.state.password, this.state.code, this.state.newPassword, this.state.newPassword2);
    }

    onClickForgotPassword(e) {
        e.preventDefault();
        if (this.props.onForgotPassword) this.props.onForgotPassword();
    }

    onClickCancel(e) {
        e.preventDefault();
        if (this.props.onCancel) this.props.onCancel();
    }

    onChange(e) {
        e.preventDefault();

        if (this.props.onChange) this.props.onChange(e.target.name, e.target.value);
        else {
            this.setState({[e.target.name]: e.target.value});
        }
    }

    render() {
        let title = this.props.title;
        if (title == null) {
            if (this.props.changePassword) title = t("Change Password");
            else title = (<span>{t("Sign in to") + " "}<b>{t("Cardserver")}</b>{" " + (this.props.askCode ? t("with password and verification code") : t("with password"))}</span>);
        }
        return (
            <form className="m-t">
                <h3>{title}</h3>
                <fieldset disabled={this.props.disabled}>
                    <div className="form-group">
                        {
                            this.props.lockEmail ?
                                <p className="form-control-static" id="email">{this.state.email}</p> :
                                <input type="email" className="form-control" placeholder="Username" name="email"
                                       value={this.state.email} onChange={this.onChange} required={true}/>
                        }
                    </div>
                    <div className="form-group">
                        <input type="password" className="form-control" placeholder="Password" name="password" autoComplete="off"
                               value={this.state.password} onChange={this.onChange} required={true}/>
                    </div>
                    {
                        this.props.askCode ?
                            <div className="form-group">
                                <input type="text" className="form-control" placeholder="Verification code" name="code"
                                       value={this.state.code} onChange={this.onChange} required={true}/>
                            </div> :
                            null
                    }
                    {
                        this.props.changePassword ?
                            <div className="form-group">
                                <input type="password" className="form-control" placeholder="New password" name="newPassword" autoComplete="off"
                                       value={this.state.newPassword} onChange={this.onChange} required={true}/>
                            </div> :
                            null
                    }
                    {
                        this.props.changePassword ?
                            <div className="form-group">
                                <input type="password" className="form-control" placeholder="New password again" name="newPassword2" autoComplete="off"
                                       value={this.state.newPassword2} onChange={this.onChange} required={true}/>
                            </div> :
                            null
                    }
                    <button type="submit" className="btn btn-primary block full-width m-b"
                            onClick={this.onClickSubmit}>{this.props.changePassword ? t("Change password") : t("Sign in")}</button>

                    {
                        this.props.onCancel ?
                            <button type="submit" className="btn btn-default block full-width m-b"
                                    onClick={this.onClickCancel}>{t("Cancel")}</button> :
                            null
                    }

                    {
                        this.props.onForgotPassword ?
                            <a href="#" onClick={this.onClickForgotPassword}>
                                <small>{t("Forgot password?")}</small>
                            </a> :
                            null
                    }
                </fieldset>
            </form>
        );
    }
}

PasswordForm.propTypes = propTypes;
PasswordForm.defaultProps = defaultProps;

export default PasswordForm;
